import { c as _c } from "react/compiler-runtime";
import type { RouterOutputs } from '@shared/all/domains/trpc';
import { ArrowLeft } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { getS3ObjectURL } from '../../utils/s3';
import Avatar from '../common/Avatar';
type HistoryData = RouterOutputs['users']['history'];
type ProfileSnapshot = HistoryData['current'];
type HistorySnapshot = HistoryData['history'][number];
type Props = {
  data: (ProfileSnapshot & {
    date: 'current';
  }) | HistorySnapshot;
};
const ProfileHistoryItem = props => {
  const $ = _c(37);
  const {
    data
  } = props;
  let t0;
  if ($[0] !== data) {
    t0 = data.date === "current" ? "Current Profile" : "changeKey" in data && data.changeKey === "tag" ? `${data.tag === "NEW" ? "Account Created" : "Bio Verified"} — ${new Date(data.date).toLocaleDateString()} at ${new Date(data.date).toLocaleTimeString()}` : `On ${new Date(data.date).toLocaleDateString()} at ${new Date(data.date).toLocaleTimeString()}`;
    $[0] = data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h3 className="text-lg font-semibold">{t0}</h3>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = `/user/${data.username}`;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowLeft />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="absolute left-4 top-4"><Link href={t2}>{t3}</Link></div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== data.bannerKey) {
    t5 = data.bannerKey ? getS3ObjectURL(data.bannerKey) : "/images/header-image-default.jpg";
    $[7] = data.bannerKey;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = data.name + " banner";
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <Image src={t5} alt={t6} width={0} height={200} sizes="100vw" className="h-48 w-full object-cover" />;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <div className="relative">{t4}{t7}</div>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = data.tag === "BOT" && !("changeKey" in data && data.changeKey === "tag");
  let t10;
  if ($[15] !== data.avatarKey || $[16] !== data.robohash || $[17] !== data.userId || $[18] !== t9) {
    t10 = <div className="mt-[-50px] flex justify-center "><Avatar avatarKey={data.avatarKey} robohash={data.robohash} isBot={t9} size={100} className="z-10" userId={data.userId} /></div>;
    $[15] = data.avatarKey;
    $[16] = data.robohash;
    $[17] = data.userId;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== data.name) {
    t11 = <h2 className="text-xl font-semibold">{data.name}</h2>;
    $[20] = data.name;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== data.username) {
    t12 = <p className="text-textSecondary/70">@{data.username}</p>;
    $[22] = data.username;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== data.bio) {
    t13 = <p className="mt-2 text-textSecondary/70">{data.bio}</p>;
    $[24] = data.bio;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t13) {
    t14 = <div className="p-4 text-center">{t11}{t12}{t13}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t10 || $[31] !== t14 || $[32] !== t8) {
    t15 = <div className="mt-4 rounded-lg bg-background-secondary shadow-md">{t8}{t10}{t14}</div>;
    $[30] = t10;
    $[31] = t14;
    $[32] = t8;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t1 || $[35] !== t15) {
    t16 = <div className="mb-8">{t1}{t15}</div>;
    $[34] = t1;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};
export default ProfileHistoryItem;